export default {
  addKeyModal: {
    action: '申し込み',
    errorMessage:
      'キーの適用中にエラーが発生しました。問題が解決しない場合は、MetricaSportsサポートチームに連絡してください',
    minutesMessage: 'あなたのキーが処理されました。%{minutes}分が利用可能になりました。',
    placeholder: 'キーを入力してください...',
    successMessage: 'キーは正常に処理されました',
    title: 'キーを追加する'
  },
  admin: {
    NoGames: 'ゲームはありません。最初のゲームを追加してください...',
    NoResults: '結果がありません...',
    addKey: 'キーを追加',
    atd: 'ATD',
    automatedTrackingData: '自動追跡データ（ATD）',
    automatedTrackingDataJobSuccess:
      '%{vpName}での自動化されたTrackingデータプロセスが完了し、現在Metrica PlayBaseで利用可能です',
    automatedTrackingDataProcessedTooltip: '処理された自動追跡データ',
    awayTeam: 'アウェイチーム',
    awayTeamScore: 'アウェイチームスコア',
    ballDetection: 'ボール検出',
    ballTracking: 'ボールTracking',
    ballTrackingProcessedTooltip: 'ボール検出が処理されました',
    ballTrackingTooltip:
      'このプロセスはボールを検出し、PlayBase内のライブフォーメーション（2Dピッチ）で視覚化することができます。ボールの座標もFIFA EPTS形式のファイルで利用可能になります。',
    cancelATDProcessSuccessfully: '自動追跡データプロセスが %{vpName} でキャンセルされました',
    cancelDataIntegrationProcessSuccessfully:
      'データ統合プロセスは %{vpName} でキャンセルされました',
    cancelEventsProcessSuccessfully: 'Smart Taggingのプロセスは%{vpName}でキャンセルされました。',
    cancelProcessTooltip: 'プロセスをキャンセルする',
    cancelSurfacesProcessSuccessfully: 'サーフェス処理が %{vpName} でキャンセルされました。',
    cancelTrackingFifaFormatProcessSuccessfully:
      'Tracking FIFA フォーマットプロセスは %{vpName} でキャンセルされました',
    category: 'カテゴリー',
    checking: 'チェック中...',
    cloudMinutes: 'GameCloud 分',
    competition: 'コンペ',
    connectionFailed: '接続に失敗しました',
    connectionFailedText:
      'ステータス情報の取得に問題があるようです。インターネット接続を確認して、ページをリロードしてください。問題が解決しない場合は、サポートに連絡してください',
    correctedTracking: 'Tracking修正処理中',
    correctionUsage: 'このビデオプロジェクトをTrackingの修正に使用しますか。',
    correctionUsageTooltip:
      'Tracking Correction Manager (TCM) は、PlayBase 内のユーザー向けモジュールで、以前に私たちの ATD で生成されたトラックを修正するためのものです。これは、どんなサッカーゲームに対しても、自動的に ID なしでデータを生成します。TCM を使用して、間違ったトラックを修正し、それらに身元を割り当ててください。詳細については、お問い合わせください。',
    createVideoProject: 'ビデオプロジェクトを作成する',
    creatingGame: 'ビデオプロジェクトを作成しています...',
    dataIntegrationFailed:
      '%{vpName} でデータ統合に失敗しました。データ統合パネルに移動し、ファイルを確認して再試行してください。エラーが続く場合は、Metrica Sports サポートチームに連絡してください',
    dataIntegrationJobSuccess: '%{vpName} のデータ統合プロセスが正常に終了しました',
    date: '日付',
    description: '説明',
    editedSuccessfully: '%{vpName} は正常に編集されました',
    errorContactSupport: 'エラーが発生しました。サポートに連絡する',
    errorProcessTooltip: 'プロセス中にエラーが発生しました',
    eventsDetection: '自動タグ付け',
    eventsDetectionProcessedTooltip: 'スマートタギング処理済み',
    eventsDetectionTooltip: {
      footer: '*30分以上のビデオで利用可能です',
      header: '私たちの技術を利用して、試合中に発生する一連のイベントを自動的に検出しましょう。'
    },
    fieldRecognition: 'フィールド検出',
    fieldTrackingProcessedTooltip: 'フィールド検出が処理されました',
    fieldTrackingTooltip:
      'PlayBaseでフィールドに応じた速度と距離の値を含むビジュアライゼーションとすべての描画を追加するためのプロセスフィールド検出。',
    fileDeletedSuccessfully: '%{fileName} は %{vpName} に対して正常に削除されました',
    fileUploadedError: '%{vpName} の %{fileName} のアップロード中にエラーが発生しました',
    fileUploadedSuccessfully: '%{fileName} が %{vpName} に対して正常にアップロードされました',
    forkedGameLimit: 'このビデオプロジェクトは別の組織に属しているため、変更することはできません',
    gameDeletedSuccessfully: '%{game} が正常に削除されました',
    gameVideoProject: 'ゲームビデオプロジェクト',
    getMoreMinutes: 'さらに入手',
    homeTeam: 'ホームチーム',
    homeTeamScore: 'ホームチームスコア',
    initializing: '初期化中...',
    jobFailed:
      '%{process} プロセスが %{vpName} に失敗しました。Metrica Sports サポートチームに連絡してください',
    liveCoding: 'またはライブコーディングを続行しますか？',
    liveCodingTooltip:
      'ライブコーディング用のビデオファイルを選択せずに、ビデオプロジェクトを作成できます。ビデオを入手したら、それを追加して、コード化されたビデオプロジェクト内に自動追跡データを含めることができます。',
    localTeamOnTheLeft: '「ホームチーム」は前半のフィールドの左サイドにありますか？',
    localTeamOnTheLeftTooltip:
      '自動タグ付けを行うには、各チームがピッチのどちら側に配置されているかを指定します。アップロードしている動画をチェックして検証してください。',
    minutes: '%{minutes} 分',
    noFootballSideViewTooltip:
      'このビデオプロジェクトには、サッカー以外の広角またはテレビ放送のビデオファイルが含まれているため、プレーヤーとチームの検出のみが処理されています。',
    noMatches: '一致するものはありません...',
    noSubscriptionOwnerTooltip:
      'サブスクリプションの Admin である「%{email}」に連絡してアップグレードするか、プランページにアクセスして独自のプランを作成してください',
    noVideoFile: 'ビデオファイルがありません',
    notPossibleToDeleteThisEntry: 'このエントリーを削除することはできません',
    numberOfHalves: 'このゲームの半分はいくつありますか？',
    numberOfHalvesTooltip:
      '自動タグ付けを処理するには、アップロードする動画に含めるゲーム期間の数を指定します。',
    oldAtdTooltip: 'このビデオは古いバージョンのATDで処理されています',
    onRequest: '要求に応じて',
    organizations: '組織',
    place: '位置',
    playerTracking: 'プレーヤーとチームの検出',
    playerTrackingProcessedTooltip: 'プレーヤーの検出が処理されました',
    playerTrackingTooltip:
      'このプロセスは、各チームのゴールキーパーと10人のフィールドプレイヤーを検出します。これにより、ライブフォーメーション（2Dピッチ）を視覚化し、PlayBaseに自動的にプレイヤービジュアライゼーションを追加することができます。プレイヤーの座標もFIFA EPTS形式ファイルで利用可能になります。',
    postProcessingData: '後処理データ...',
    preProcessingAtd: '前処理中...',
    processingTooltip: '処理中...',
    readyToUpload: 'アップロードする準備ができました',
    search: '検索...',
    selectVideoFile: 'ビデオファイルを選択',
    settingUpAtd: '検出をセットアップ中...',
    settings: '設定',
    singleVideoProject: 'シングルビデオプロジェクト',
    startAtd: 'ATDを開始します',
    startFifaMessage:
      '%{vpName} の FIFA 統合プロセスが開始されました。完了したら通知を表示しますので、しばらくお待ちください。',
    startProcessingWaitingJobsFailed: '待機中のジョブの送信に失敗しました',
    startProcessingWaitingJobsSuccessfully: '待機中のジョブが正常に送信されました',
    startSsMessage:
      '%{vpName} の Second Spectrum 統合プロセスが開始されました。完了したら通知を表示しますので、しばらくお待ちください。',
    startStatsMessage:
      '%{vpName} の Stats 統合プロセスが開始されました。完了したら通知を表示しますので、しばらくお待ちください。',
    startTracabDflMessage:
      '%{vpName} の Tracab DFL 統合プロセスが開始されました。完了したら通知を表示しますので、しばらくお待ちください。',
    startTracabMessage:
      '%{vpName} の Tracab 統合プロセスが開始されました。完了したら通知を表示しますので、しばらくお待ちください。',
    surfacesJobSuccess: '%{vpName} サーフェスプロセスが正常に終了しました',
    trackingCorrectionProcessedTooltip: 'Tracking修正処理済み',
    trackingFifaFormatJobSuccess:
      '%{vpName} の FIFA フォーマットプロセスの Tracking は正常に終了しました。これで、FIFA 形式のダウンロードメニュー項目をクリックしてファイルをダウンロードできます。',
    trackingLicence: 'Trackingライセンスがありません',
    uncaughtErrorRow:
      'ビデオプロジェクトエラー。このページを更新してください。問題が解決しない場合は、サポートに連絡するか、削除して再作成してください',
    updatingGame: 'ビデオプロジェクトを更新中...',
    upgradePlan: 'アップグレード',
    uploadAndTracking: 'アップロードとTracking',
    uploadingVideoFile: 'ビデオファイルのアップロード',
    videoFile: 'ビデオファイル',
    videoFootballSideView: 'このビデオファイルはサッカーの広角またはテレビ放送ですか？',
    videoFootballSideViewTooltip:
      'フィールド検出は、これらのタイプのビデオに対してのみ最適化されています。',
    videoMultipartStart:
      '%{videoName} は %{vpName} にアップロードされています。アップロードが完了するまで、このページを閉じないでください',
    videoPlaylist: 'このビデオファイルは再生リストですか？',
    videoPlaylistTooltip:
      'YESを選択すると、Clip Detectionが実行され、ビデオ内でカットが発生している場合を認識します。これは、例えば、複数のクリップを含むビデオをアップロードしている場合に最適なツールです。このプロセスを実行した後、PlayBaseでビデオプロジェクトをダウンロードすると、各カットをイベントとして含むコードを含むClip DetectionのCodingファイルがそこにあります。',
    videoProjectSettings: 'ビデオプロジェクトの設定',
    videoUploadError:
      '%{vpName} の %{videoName} の動画アップロードに失敗しました。もう一度やり直してください',
    videoUploaded: '%{videoName} が %{vpName} にアップロードされました',
    vpCreated: '%{vpName} が作成されました',
    waitingAtd: '待機中…'
  },
  billing: {
    address: '住所',
    billed: '請求済み',
    completed: '支払済み',
    details: '請求の詳細',
    history: '請求履歴',
    invoiceNotFound: '請求書が見つかりません',
    noInvoices: '請求書がありません',
    past_due: '期限切れ',
    taxId: '納税者番号'
  },
  checkout: {
    chargeSubscription: 'サブスクリプションに課金する',
    costOneTime: '%{currency} %{cost}',
    costRecurrent: '%{currency} %{cost} %{cycle}',
    discountCodes: '*割引コードはチェックアウト時に適用できます',
    dueToday: '今日支払う',
    excTax: '（税抜き）',
    halfYear: '6ヶ月',
    halfYearlyBilled: '6ヶ月ごとに請求されます',
    immediatePayment: '即時支払い',
    incTax: '(税込)',
    month: '月',
    monthlyBilled: '月額請求',
    nextPayment: '次の支払い',
    noPacks: 'GameCloudの分なし',
    onDate: '%{date}に',
    packs: 'パック',
    packsTotal: 'トータルパック',
    perHalfYear: '/6ヶ月',
    perMonth: '/月',
    perYear: '/年',
    plans: 'プラン',
    plansTotal: 'プラン合計',
    proceed: 'レジに進む',
    subtotal: '小計',
    taxPayable: '支払うべき税金（%{percentage}%）',
    total: '合計',
    unpaid:
      'あなたの最新の請求書はまだ支払われていません。続行するには、お支払い情報を更新してください。',
    updatePaymentMethod: '支払い方法を更新する',
    updateSubscription: 'サブスクリプションを更新する',
    upgradeTo: '%{plan} にアップグレード',
    userDevice: '1ユーザー/デバイス',
    usersDevices: '%{number} ユーザー/デバイス',
    year: '年',
    yearlyBilled: '年間請求'
  },
  common: {
    add: '追加',
    back: '戻る',
    cancel: 'キャンセル',
    canceling: 'キャンセル中...',
    clearAll: 'すべてクリア',
    continue: '続ける',
    create: '作成する',
    deactivate: '無効にする',
    edit: '編集',
    email: 'Eメール',
    errorMsg: '%{name} の処理中にエラーが発生しました。お問い合わせはサポートまでご連絡ください。',
    errorTryAgain: 'エラー。もう一度お試しください',
    genericError: 'エラー、プロセスが失敗しました。お問い合わせはサポートまでご連絡ください。',
    loading: 'ロード中…',
    login: 'ログイン',
    logout: 'ログアウト',
    new: '新しい',
    next: '次',
    no: 'No',
    noFileChosen: 'ファイルが選択されていません',
    ok: 'OK',
    pending: '保留中',
    required: '必須',
    reset: 'パスワードを再設定する',
    restart: '再起動',
    save: '保存',
    selectFile: 'ファイルを選ぶ',
    sort: '選別',
    start: '始める',
    today: '今日',
    unassigned: '未割り当て',
    uploading: 'アップロード中...',
    yes: 'Yes'
  },
  confirmModal: {
    description: 'よろしいですか？',
    title: '確認'
  },
  container: {
    download: 'コンテナファイルをダウンロード',
    notProcessed: 'このVideo Projectでは、Contenedorファイルが処理されていません。',
    processed: 'コンテナファイルが処理されました',
    title: 'コンテナ',
    titleDownload: 'コンテナをダウンロード'
  },
  dataIntegration: {
    deleteFile: 'ファイルを削除する',
    featureNotAvailable:
      'この機能は、現在のプランでは利用できません。この機能を使用するには、別のプランにアップグレードする必要があります。詳細についてはお問い合わせください',
    notSideView:
      'データ統合は、サッカー以外の広角またはTV放送のビデオファイルを含むビデオプロジェクトでは使用できません。',
    open: 'データ統合を開く',
    processJobsFirst:
      '[データ統合]パネルにアクセスする前に、まず自動追跡データ（ATD）の処理を開始する必要があります',
    processed: '処理されたデータ統合',
    selectFile: 'ファイルを選ぶ',
    startProcess: 'プロセスの開始',
    title: 'データ統合',
    waiting: '待機中...',
    waitingProcess: 'プレーヤーとフィールドの検出プロセスが完了すると、統合プロセスが開始されます。'
  },
  deleteModal: {
    checkboxLabel: 'MetricaSportsからのメール受信も停止したい',
    confirmationType: '%{validateFormKey} と入力して、次のことを確認します。',
    deleteAction: 'Yes、削除します',
    description: 'アカウントを完全に削除してもよろしいですか？',
    information:
      'このアカウントで作成されたすべてのビデオプロジェクトが失われます。一度削除すると復旧できません。',
    keepAccount: 'アカウントを保持する',
    suggestion: 'アカウントを保持することをお勧めします。',
    title: '永遠に削除しますか？',
    validateFormKey: '削除'
  },
  error: {
    oops: 'おっと ！',
    restart: 'あなたは現在開発中のものに入ろうとしてるようです...'
  },
  eventsDetection: {
    automaticVp: 'Smart Taggingは、古いATDバージョンのビデオプロジェクトでは利用できません。',
    download: 'Smart Tagging イベントを XML 形式でダウンロード',
    needsAtd: 'スマートタギングプロセスを実行するために、最初にATDプロセスを開始してください。',
    needsFootballSideView:
      'スマートタグ付けは、サッカー/フットボール以外の広角またはテレビ放送のビデオファイルを含むビデオプロジェクトでは利用できません。',
    needsGameVp: 'スマートタギングは、ゲームビデオプロジェクトでのみ利用可能です。',
    needsNoPlaylist:
      'スマートタグ付けは、プレイリストのビデオファイルを含むビデオプロジェクトでは利用できません。'
  },
  forgotPassword: {
    adminNoResetPassword:
      '管理者ユーザは、パスワードのリセットにプライベートエンドポイントを使用する必要がある',
    notFound: 'ユーザーが見つかりません。有効なメールアドレスでもう一度お試しください',
    success: 'パスワードがリセットされました！ メールを確認してください'
  },
  groups: {
    addMembers: 'メンバーを追加する',
    addOrUpdateErrorMessage:
      'グループの処理中にエラーが発生しました。問題が解決しない場合は、Metrica Sportsのサポートチームに連絡してください',
    availableMinutes: '利用可能な分',
    availableMinutesWarning: '%{availableMinutes}分を何かの組織に割り当てることができます',
    createGroup: 'グループを作成',
    deleteErrorMessage:
      'グループの削除時にエラーが発生しました。問題が解決しない場合は、Metrica Sportsのサポートチームに連絡してください',
    deleteGroup: 'グループを削除',
    deleteGroupDescription:
      'グループ%{pre}%{name}%{post}を削除しようとしています。このグループにリンクされているVideo Projectがある場合、ユーザーはそれにアクセスできなくなります。',
    deleteNow: '今すぐ削除',
    deleteThisGroup: 'このグループを削除する',
    editGroup: 'グループを編集',
    enterEmails: '追加したいユーザーのメールアドレスを入力してください',
    enterGroupName: 'グループ名を入力してください',
    enterValidName: '有効な名前を入力してください',
    gameCloudMinutes: 'GameCloud 分',
    groupMembers: 'グループのメンバー',
    groupName: 'グループ名',
    manageGameCloudMinutes: 'GameCloud 分を管理する',
    minutesErrorMessage:
      '分の管理にエラーが発生しました。問題が解決しない場合は、Metrica Sportsのサポートチームに連絡してください',
    moreLicensesDescription:
      'アカウントにライセンスユーザーを追加するには、追加のライセンスを購入してください',
    name: 'グループ名',
    noMultiLicenseDescription: 'マルチライセンスプランのみがグループを作成できます',
    noPermissionDescription:
      'あなたのユーザーは%{pre}%{ownerEmail}%{post}組織に属しています。アップグレードや変更を行うには、所有者に連絡してください'
  },
  login: {
    clickHere: 'こちらをクリック\n',
    contactUs: 'お問い合わせ',
    dontHaveAccount: 'アカウントがありません。%{pre}サインアップ%{post}',
    enterYourEmail: 'メールアドレスを入力',
    enterYourPassword: 'パスワードを入力してください',
    forgotPassword: 'パスワードを忘れました。%{pre}こちらをクリック%{post}',
    invalidEmail: '無効なメールアドレス',
    licenceExpired: 'ライセンスの有効期限が切れています。',
    trialExpired: 'ご利用のトライアルは終了しています。',
    upgradePlan: 'プランをアップグレードする'
  },
  patterns: {
    delete: 'パターンファイルを削除する',
    title: 'カスタムパターンファイル',
    upload: 'カスタムパターンファイルをアップロードする',
    uploaded: 'アップロードされたパターンファイル',
    uploading: 'パターンファイルのアップロード'
  },
  plans: {
    academic: 'アカデミック',
    addMoreProducts: '+ 製品を追加する',
    admin: 'Admin',
    basic: 'Basic',
    basicCodePadMonthly: 'Basic+Code 月額',
    basicCodePadYearly: 'Basic+Code 年間',
    basicMftCodePadMonthly: 'Full Basic 月額',
    basicMftCodePadYearly: 'Full Basic 年間',
    basicMftMonthly: 'Basic+MFT 月額',
    basicMftXmlMonthly: 'Basic MFT + XML 月額',
    basicMftXmlYearly: 'Basic MFT + XML 年間',
    basicMftYearly: 'Basic+MFT 年間',
    basicMonthly: 'Basic 月額',
    basicXmlMonthly: 'Basic XML 月額',
    basicXmlYearly: 'Basic XML 年間',
    basicYearly: 'Basic 年間',
    code: 'Code',
    elite: 'Elite',
    elite2024Yearly: 'エリート年間',
    eliteYearly: 'Elite 年間',
    essentialsCodeMonthly: 'Essentials + Code ∞ 月額',
    essentialsCodeYearly: 'Essentials + Code ∞ 年間',
    essentialsMftCodeMonthly: 'フルエッセンシャルズ月額',
    essentialsMftCodeYearly: 'フルエッセンシャル年間',
    essentialsMftMonthly: 'Essentials + MFT 月額',
    essentialsMftYearly: 'Essentials + MFT 年間',
    essentialsMonthly: 'Essentials 月額',
    essentialsYearly: 'Essentials 年間',
    influencer: 'Influencer',
    lite: 'Lite',
    liteMonthly: 'Lite 月額',
    liteYearly: 'Lite 年間',
    minutes10: '10分のGameCloud',
    minutes100: '100 GameCloud 分',
    minutes1000: '1,000 GameCloud 分',
    minutes10000: '10,000 GameCloud 分',
    plan: '%{planName} プラン',
    planHalfYearly: '%{planName} 半年プラン',
    planMonthly: '%{planName} 月額プラン',
    planYearly: '%{planName} 年間プラン',
    primeLiveMonthly: 'Prime + Live 月額',
    primeLiveYearly: 'Prime + Live 年間',
    primeMftLiveMonthly: 'Prime + MFT + ライブ 月額',
    primeMftLiveYearly: 'Prime + MFT + ライブ 年間',
    primeMftMonthly: 'プライム + MFT 月額',
    primeMftYearly: 'プライム + MFT 年間',
    primeMonthly: 'プライム月額',
    primePresetsLiveMonthly: 'Prime + Presets + Live 月額',
    primePresetsLiveYearly: 'Prime + Presets + Live 年間',
    primePresetsMftLiveMonthly: 'Full Prime 月額',
    primePresetsMftLiveYearly: 'Full Prime 年間',
    primePresetsMftMonthly: 'Prime + Presets + MFT 月額',
    primePresetsMftYearly: 'Prime + Presets + MFT 年間',
    primePresetsMonthly: 'プライム + プリセット 月額',
    primePresetsYearly: 'プライム + プリセット 年間',
    primeYearly: 'プライム年間',
    pro: 'Pro',
    pro2024LiveMonthly: 'Pro + Live 月額',
    pro2024LiveYearly: 'Pro + Live 年間',
    pro2024Monthly: 'プロ月額',
    pro2024Yearly: 'プロ年間',
    proYearly: 'Pro 年間',
    starter: 'Starter',
    starterCodeMonthly: 'スターター + コード ∞ 月額',
    starterCodePadMonthly: 'Code 月額',
    starterCodePauseMonthly: 'フルスターター月額',
    starterCodePauseYearly: 'フルスターター年間',
    starterCodeYearly: 'スターター + コード ∞ 年間',
    starterPauseMonthly: 'スターター + ポーズ ∞ 月額',
    starterPauseYearly: 'スターター + ポーズ ∞ 年間',
    student: '学生',
    trial: 'Trial'
  },
  playlist: {
    download: 'プレイリストファイルをダウンロード',
    notProcessed: 'プレイリストファイルは、このビデオプロジェクトでは処理されませんでした。',
    processed: 'プレイリストファイルが処理されました',
    title: 'プレイリスト',
    titleDownload: 'プレイリストをダウンロード'
  },
  products: {
    addOns: 'アドオン',
    basic: '無制限のコード＆アノテーション',
    code: 'CodePad',
    elite: {
      description:
        '分析ワークフローを自動化し、カスタマイズします。このプランには、"Full Essentials" プランの全機能と、"Pro" プランの全機能を備えたPlayBaseへの完全アクセス、及びMetrica Nexusへのアクセスが含まれます。',
      feature1: '✓ 共有クラウドストレージ',
      feature2: '✓ トラッキングデータの統合',
      feature3: '✓ トラッキング修正マネージャー',
      feature4: '✓ RESTful API'
    },
    essentials: {
      addon1: '無制限のCoding機能（CodePad、ライブCoding、XMLインポート）',
      addon2: 'マニュアルフィールドトラッキング',
      essentialsCodeDescription:
        'このプランでは、ビデオの再生時および一時停止時に無制限の動きのビジュアライゼーションを追加できるダイナミックテレストレーションが利用可能になります。このプランにはマニュアルフィールドトラッキングが含まれていないため、速度と距離のビジュアライゼーションは含まれません。また、CodePad、ライブコーディング、XMLインポートなどのコーディング機能の制限を解除し、ビデオプロジェクトごとのコードの制限を4つから無制限にします。',
      essentialsDescription:
        'このプランでは、ビデオの再生時および一時停止時に無制限の動きのビジュアライゼーションを追加できるダイナミックテレストレーションが利用可能になります。このプランにはマニュアルフィールドトラッキングが含まれていないため、速度および距離のビジュアライゼーションは含まれません。コーディング機能は限定されています。',
      essentialsMftCodeDescription:
        'このプランでは、ビデオの再生時および一時停止時に無制限の動きのビジュアライゼーションを追加できるダイナミックテレストレーションが利用可能になり、マニュエルフィールドトラッキングも有効になり、速度と距離のビジュアライゼーションを追加できます。また、CodePad、ライブコーディング、XMLインポートなどのコーディング機能の制限を解除し、ビデオプロジェクトごとのコードの制限を4つから無制限にします。',
      essentialsMftDescription:
        'このプランは、ビデオの再生時および一時停止時に無制限の動きのビジュアライゼーションを追加できるダイナミックテレストレーションを有効にし、マニュエルフィールドトラッキングも活性化して、速度と距離のビジュアライゼーションを追加できます。コーディング機能は限定されたままです。',
      feature1: '✓ 試合後のコーディング（最大4つのコードを含むCode Table）',
      feature2: '✓ 一時停止中の無制限のテレストレーション',
      feature3: '✓ ダイナミックテレストレーション'
    },
    featuresIncluded: '含まれる機能:',
    freeFeature1: '✓ 試合後のコーディング（最大4つのコードを含むCode Table）',
    freeFeature2: '✓ キーフレーミング',
    freeFeature3: '✓ テレストレーション（最大50の注釈まで）',
    freeFeature4: '✓ ビデオエクスポート',
    freeFeatures: '無料機能',
    fullBasic: 'マニュアルフィールドトラッキング',
    lite: '自動選手＆フィールドトラッキング',
    liteDescription:
      '高度なCodingと高度なビジュアライゼーション。全てが自動で、Full Basicよりも3倍速い！',
    minutesDescription:
      'どのプランでもチャージしてください。自動追跡データ用の分パックを入手してください。',
    minutesPack: 'GameCloud ミニッツ パック',
    nexus_elite: {
      description: '世界中の最高のチームのために',
      feature1: '✓ すべての Pro 機能',
      feature2: '✓ Full Clip Tracking',
      feature3: '✓ Nexus Live (ライブキャプチャー + Nexus モバイル)'
    },
    nexus_prime: {
      addon1: 'Nexus Live (ライブキャプチャー + Nexus モバイル)',
      description: 'エントリーレベルソリューション',
      feature1: '✓ フルゲーム分析',
      feature2: '✓ フル Telestration',
      feature3: '✓ マニュアル Tracking'
    },
    nexus_pro: {
      addon1: 'Nexus Live (ライブキャプチャー + Nexus モバイル)',
      description: 'ワークフローを自動化する',
      feature1: '✓ フルゲーム分析',
      feature2: '✓ 完全なTelestration',
      feature3: '✓ 自動 Tracking'
    },
    otherDescription:
      '基本的なテレストレーションと限定されたアノテーションを備えた高度なcoding機能',
    playbase_advanced: {
      description: '完全自動化された分析',
      feature1: '✓ フルゲーム分析',
      feature2: '✓ モーションでのTelestration',
      feature3: '✓ 自動 Tracking'
    },
    playbase_essentials: {
      description: 'エントリーレベルソリューション',
      feature1: '✓ フルゲーム分析',
      feature2: '✓ ポーズ中のテレストレーション'
    },
    playbase_plus: {
      description: '自分のペースでTrackingを行う',
      feature1: '✓ フルゲーム分析',
      feature2: '✓ モーションでのTelestration',
      feature3: '✓ マニュアル Tracking'
    },
    prime: {
      addon1: 'マニュアルフィールドトラッキング',
      addon2: 'プリセットテレストレーション（カスタマイズして自分のビジュアライゼーションを保存）',
      addon3: 'ライブ録画（キャプチャ、分析し、移動中にハイライトを共有）',
      feature1: '✓ "Full Essentials" プランの全機能を備えたPlayBaseへの完全アクセス',
      feature2: '✓ Metrica Nexusへのアクセス：',
      feature2_1: 'シーケンシャルポーズ',
      feature2_2: '高度なテレストレーション',
      feature2_3: 'カスタムビデオエクスポート',
      primeDescription:
        'このプランには、"Essentials + Code ∞" プランの全機能と共にPlayBaseへの完全アクセスが含まれ、高度なテレストレーションを備えたMetrica Nexusが利用可能になります。',
      primeMftDescription:
        'このプランには、"Full Essentials"プランの全機能と共にPlayBaseへの完全アクセスが含まれ、高度なテレストレーションを備えたMetrica Nexusが利用可能になります。',
      primePresetsDescription:
        'このプランには、"Essentials + Code ∞" プランの全機能と共にPlayBaseへの完全アクセスが含まれ、高度なテレストレーションとカスタムビジュアライゼーションを備えたMetrica Nexusが利用可能になります。',
      primePresetsMftDescription:
        'このプランには、"Full Essentials"プランの全機能と共にPlayBaseへの完全アクセスが含まれ、高度なテレストレーションとカスタマイズされたビジュアライゼーションを備えたMetrica Nexusが利用可能になります。'
    },
    pro: {
      addon1: 'ライブ録画（キャプチャ、分析、そして移動中にハイライトを共有）',
      description:
        'このプランには、"Full Essentials"プランの全機能とPlayBaseへの完全アクセス、及び"Full Prime"プランの全機能とMetrica Nexusへのアクセスが含まれています。',
      feature1: '✓ 自動選手追跡',
      feature2: '✓ 自動フィールドトラッキング',
      feature3: '✓ 「Full Essentials」プランの全機能を備えたPlayBaseへの完全アクセス',
      feature4: '✓ Metrica Nexusへのアクセス：',
      feature4_1: 'シーケンシャルポーズ',
      feature4_2: '高度なテレストレーション',
      feature4_3: 'カスタムビデオエクスポート',
      feature4_4:
        'プリセットテレストレーション（カスタマイズして自分のビジュアライゼーションを保存）'
    },
    remove: '削除',
    starter: {
      addon1: 'ポーズ中の無制限テレストレーション',
      addon2: '無制限のCoding機能（CodePad、ライブCoding、XMLインポート）',
      feature1: '✓ 試合後のコーディング（最大4つのコードを含むCode Table）',
      feature2: '✓ 一時停止中のテレストレーション（月に最大50の注釈まで）',
      feature3: '✓ ビデオエクスポート',
      starterCodeDescription:
        'このプランは、CodePad、ライブCoding、XMLインポートなどのcoding機能の制限を解除します。また、ビデオプロジェクトごとのコードの制限を4つから無制限に解放します。Free Starterからの視覚化機能の制限はそのままです。',
      starterCodePauseDescription:
        'このプランは、CodePad、ライブコーディング、XMLインポートなどのコーディング機能の制限を解除します。また、ビデオプロジェクトごとのコードの制限を4つから無制限に解放し、月に50回の一時停止中のテレストレーションの制限を無制限に解除します。',
      starterPauseDescription:
        'このプランは、一時停止中のテレストレーションの制限を月50回から無制限に解除します。コーディング機能の制限はFree Starterのままです。'
    },
    totalPack: '%{currency} %{cost}'
  },
  settings: {
    billing: '請求',
    billingSettings: '請求設定',
    billingSettingsDescription: '（プランを変更し、支払い方法を更新してください...）',
    cancelAt: 'あなたのプランがキャンセルされるのは',
    cancelPlan: 'プランをキャンセルする',
    confirmNewPassword: '新しいパスワードを確認',
    deleteAccount: 'アカウントを削除する',
    details: '私の詳細',
    devices: 'デバイス',
    devicesResetError: 'デバイスをリセットする際のエラーが発生しました。もう一度お試しください',
    devicesResetSuccess: 'すべてのデバイスが正常にリセットされました',
    emailNotActivated: 'メール通知が有効になりました',
    emailNotDeactivated: 'メール通知を停止しました',
    emailNotifications: 'メール通知',
    groups: 'グループ',
    language: '言語',
    languageChanged: '言語が更新されました',
    manualResetDevices: 'デバイスをリセットするにはサポートに連絡してください',
    newPassword: '新しいパスワード',
    noDevicesToReset: 'リセットするデバイスがありません',
    noOwner:
      'あなたのプランは%{pre}%{email}%{post}組織に属しています。アップグレードまたは変更を行うには、所有者に連絡してください',
    organizationLabel: '組織の接頭辞',
    organizationTooltip:
      'この接頭辞は、カスタムパターンを Video Project にインポートする際に必要です。詳しくはお問い合わせいただくか、codeball.metrica-sports.com のドキュメントをご覧ください。',
    passwordsDontMatch: 'パスワードが一致しません',
    passwordInvalid: 'パスワードが要件を満たしていません',
    passwordRequirements: {
      minLength: '%{count}文字以上',
      uppercase: '大文字を1文字',
      lowercase: '小文字を1文字',
      number: '数字を1文字（0-9）',
      maxLength: '%{count}文字以下'
    },
    pauseAt: 'あなたのプランは次の日に一時停止します。',
    planCanceled: 'プランはキャンセルされました。詳細については、メールを確認してください。',
    plans: 'プラン',
    quantity: '量：',
    remainingResets: '%{current}/%{max} 今年残りのスイッチ回数',
    renewAt: 'プランの更新日',
    resetDeviceAction: 'デバイスをリセット',
    title: '設定',
    upgradePlan: 'アップグレードプラン',
    userKey: 'ユーザーキー:',
    userKeyUsages: '%{current}/%{max} の使用量',
    userSettings: 'ユーザー設定',
    users: 'ユーザー'
  },
  shoppingCart: {
    subtitle: 'Metrica Sportsのプランとアドオンを選択して、パフォーマンスを向上させましょう。',
    title: 'あなたのMetrica Sportsを設定してください'
  },
  subscription: {
    cancelSubscription: '登録をキャンセルする',
    errorUpdating:
      'あなたのサブスクリプションを更新中にエラーが発生しました。support@metrica-sports.comまでメールを送ってください。喜んでお手伝いします。',
    free: '無料',
    isObsolete:
      'あなたのサブスクリプションは変更できません。変更を有効にするために、古い製品を新しいものに置き換えてください。',
    pendingRefundRequest:
      'このサブスクリプションに対して返金リクエストが保留中の間、これ以上の変更を加えることはできません。',
    planMigrationMessage:
      "4月1日から、あなたの<strong>%{currentPlan}</strong>サブスクリプションは<strong>%{newPlan}</strong>と呼ばれるようになりますが、料金は発生しません。あなたからのアクションは必要ありません。<strong>%{date}</strong>には、プランの価格は<strong>%{newPrice}</strong>／ユーザー、<strong>%{cycle}</strong>ごとになります。新しいプランについてもっと知りたい場合は、<a href='%{link}'>こちらをクリック</a>してください。",
    undoCancel: 'サブスクリプションのキャンセルを取り消す',
    undoPause: 'サブスクリプションの一時停止を解除',
    updatePaymentMethod: '支払い方法を更新する',
    updatedSuccessfully: 'サブスクリプションが正常に更新されました。',
    yourPlans: 'あなたのプラン',
    yourSubscription: 'あなたのサブスクリプション'
  },
  successfulPayment: {
    addUsers: '組織に他のユーザーを追加してください。',
    allTheBest: 'すべてが最高でありますように,',
    applyKey: 'このアカウントにキーを適用する',
    applyKeyDescription: 'このライセンスをあなたのアカウントにアクティベートしますか？',
    assignLicenses: 'ライセンスを別のアカウントに転送します。',
    download:
      '私たちのウェブサイトの%{pre}ダウンロードページ%{post}にアクセスして、ライセンスに応じてPlayBaseまたはNexusをダウンロードしてください。',
    faq: 'ここでは、すぐに始める方法とその他の関連情報を紹介します：',
    happyPlay:
      'すべてが明確であることを願っていますが、さらに質問や疑問がある場合は、遠慮なく私たちに連絡してください。',
    helpCenter:
      '多くの役立つ記事、完全なチュートリアルやよくある質問など、%{pre}Help Center%{post}をチェックしてください。',
    howToCancel:
      'ご注意ください。お客様のサブスクリプションは、当社の利用規約に従い、GameCloudの設定を通じて明示的に%{pre}キャンセル%{post}されるまで自動的に更新されます。',
    keyApplied: 'キーが適用されました',
    licenseActivation1:
      'アカウントにまだアクティブなライセンスがなかった場合、新しく購入したライセンスは自動的にアクティブ化されました。',
    licenseActivation2:
      '何らかの理由でライセンスがアクティベートされていない場合は、以下でアクティベートできます：',
    licenseKey: 'あなたのライセンスキーは：%{pre}%{licenseKey}%{post}です。',
    licensesTitle: 'ライセンスのアクティベーション',
    metricaSportsTeam: '— メトリカ・スポーツのチーム',
    minutesInfo:
      'GameCloudの分を異なるユーザーグループに配分したい場合は、%{pre}設定ページ%{post}内のグループタブに移動してください。',
    minutesTitle: 'あなたのGameCloud分',
    renewalInfo:
      'ご注意ください。お客様のサブスクリプションは、当社の利用規約に従い、GameCloudの設定を通じて明示的に%{pre}キャンセル%{post}されるまで自動的に更新されます。',
    settingsCloud: '%{pre}GameCloud%{post}にアクセスして、設定メニューに移動してください：',
    technicalSupport: '技術サポートが必要な場合は、%{pre}直接お問い合わせください%{post}。',
    thanks: 'ご注文いただきありがとうございます、成功裏に処理しました！',
    title: '注文確認',
    updatePayment: '支払い方法を更新してください。',
    updateSubscription: 'あなたのサブスクリプションをキャンセルまたは変更してください。'
  },
  surfaces: {
    automaticVp: '古いATDバージョンのビデオプロジェクトではサーフェスはご\n利用頂けません',
    delete: 'サーフェスファイルの削除',
    needsAtd: '最初にATDプロセスを開始して、サーフェスプロセスを実行します',
    needsElite:
      'Eliteプランでは、カスタムサーフェスがご利用いただけます。詳しくはお問い合わせください。',
    needsFootballSideView:
      'サッカー以外の広角またはテレビ放送のビデオファイルを含むビデオプロジェクトではサーフェスはご利用頂けません。',
    pitchControl: 'このプロセスを実行することで、PlayBaseにPitch Controlの可視化を追加できます。',
    pitchControlProcessed: 'Pitch Controlサーフェスが処理されました',
    pitchControlProcessing: 'Pitch Controlの処理中',
    processed: 'アップロードされたサーフェスファイル',
    processing: 'サーフェスファイルの処理',
    title: 'サーフェス',
    titlePitchControl: 'Pitch Control',
    upload: '独自のサーフェスをアップロードする',
    uploading: 'サーフェスをアップロードしています...'
  },
  trackingFifaFormat: {
    download: 'FIFA EPTSフォーマットファイルをダウンロードする',
    needsElite:
      'この機能は、データ統合モジュール、自動追跡データ付きビデオプロジェクト、またはEliteプランのビデオプロジェクトに対応するファイルをインポートした後にのみご利用頂けます。',
    processed: 'FIFA EPTSフォーマットが処理されました',
    start:
      'FIFA EPTS形式のファイルを生成するプロセスを開始します。その後、ファイルをダウンロードできるようになります',
    title: 'FIFA EPTSフォーマット',
    titleDownload: 'FIFA EPTSフォーマットをダウンロード'
  },
  upgradeModal: {
    linksDescription: 'あなたに最適なGameCloudの分パックを手に入れよう：',
    minutePackLinks: {
      minutes_10: '10分10€でご利用いただけます。',
      minutes_100: '100分90€でご利用いただけます。',
      minutes_1000: '1,000分750€でご利用いただけます。',
      minutes_10000: '10,000分5,000€でご利用いただけます。'
    },
    noMinutes: {
      description:
        'このビデオプロジェクトを作成するのに十分な時間がありません。どのプランでも時間料金パックを手に入れることができることをご存じですか？',
      secondDescription: '',
      title: 'ビデオプロジェクトを作成するためのより多くの時間を取得してください！'
    },
    notEnoughMinutes: {
      description: 'ビデオプロジェクトのATDプロセスに十分な時間がないことをお知らせします。',
      secondDescription:
        'ATDを処理する場合は、アカウントにさらに時間を追加する必要があります。得た時間に有効期限はありません！',
      title: '十分な時間がありません'
    }
  },
  users: {
    addEmails: 'メールアドレスでユーザーを追加する',
    addErrorMessage:
      'ユーザーを追加する際のエラーが発生しました。問題が解決しない場合は、Metrica Sportsのサポートチームに連絡してください',
    addUsers: 'ユーザーを追加する',
    availableLicenses: '%{planName} (%{count}利用可能%{renewal})',
    currentLicense: '%{planName}（現在の%{renewal}）',
    deactivateErrorMessage:
      'ユーザーの無効化エラー。問題が解決しない場合は、Metrica Sportsサポートチームに連絡してください',
    deactivateNow: '今すぐ無効化する',
    deactivateUser: 'ユーザーを無効にする',
    deactivateUserDescription:
      'ユーザー%{pre}%{email}%{post}を無効にしようとしています。ユーザーはMetrica Sportsのどのサービスにもアクセスできなくなり、無料プランに変更されます。',
    editUser: 'ユーザーを編集',
    enterGroup: 'グループを入力',
    exportUsers: 'ユーザーをエクスポート',
    filteredUsers: '%{nUsers} / %{totalUsers} ユーザー',
    firstName: '名前',
    lastName: '姓',
    plan: 'プラン',
    renewsOn: '、%{date}に更新',
    role: '役割',
    roles: {
      admin: '管理者',
      member: 'メンバー',
      owner: 'オーナー'
    },
    unlinkErrorMessage:
      'ユーザーのリンク解除エラーです。問題が続く場合は、Metrica Sportsのサポートチームに連絡してください',
    unlinkFromYourAccount: 'アカウントからのリンク解除',
    unlinkNow: 'リンク解除する',
    unlinkUser: 'ユーザーをリンク解除',
    unlinkUserDescription:
      'ユーザー%{pre}%{email}%{post}のリンクを解除しようとしています。ユーザーはMetrica Sportsのサービスにアクセスできなくなり、Freeプランに変更されます。',
    updateErrorMessage:
      'ユーザーの更新時にエラーが発生しました。問題が解決しない場合は、Metrica Sportsのサポートチームに連絡してください',
    useComma: '異なるメールアドレスを区切るには、コンマを使用してください',
    userGroups: 'ユーザーグループ'
  },
  video: {
    cancelUpload: 'アップロードをキャンセル',
    delete: 'ビデオを削除する',
    download: 'ビデオをダウンロード',
    title: 'ビデオファイル',
    upload: 'ビデオをアップロード',
    uploaded: 'アップロードされたビデオ',
    uploading: 'ビデオのアップロード'
  },
  videoProject: {
    delete: 'ビデオプロジェクトを削除する',
    edit: 'ビデオプロジェクトの編集',
    processWaitingJobs: '待機中のジョブを処理する',
    title: 'ビデオプロジェクト'
  }
}
